export const header = {
    matching: 'Matching',
    messages: 'Messages',
    projects: 'Projects',
    releaseNotes: 'Release notes',
    savedSearch: 'Saved search',
    talentSearch: 'Talent search',
};
